import { useState } from 'react'
import { apiPost, apiPatch } from '../../api'
import type { MentionRow } from '../../api'

interface Props {
  rows: MentionRow[]
  onChange: () => void
}

export default function MentionedNotes({ rows, onChange }: Props) {
  const [text, setText] = useState('')

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    const v = text.trim()
    if (!v) return
    setText('')
    await apiPost('/home/mentions', { note: v })
    onChange()
  }

  const resolve = async (id: number) => {
    const resolution = prompt('Optional resolution note:') ?? undefined
    await apiPatch(`/home/mentions/${id}`, resolution ? { resolution } : {})
    onChange()
  }

  return (
    <div className="mention-list">
      <form onSubmit={submit}>
        <input
          type="text"
          placeholder="Something she said…"
          value={text}
          onChange={e => setText(e.target.value)}
        />
      </form>
      {rows.length === 0 && <div className="empty-state">Nothing open.</div>}
      {rows.map(r => (
        <div key={r.id} className="row">
          <span className="grow">{r.note}</span>
          <button type="button" onClick={() => resolve(r.id)} style={{ minHeight: 32, padding: '0.25rem 0.6rem' }}>✓ resolved</button>
        </div>
      ))}
    </div>
  )
}
